import React, { useState } from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const MarketPlace = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleCreatorClick = () => {
    setOpen(true);
  };

  const handleSkip = () => {
    setOpen(false);
    navigate('/marketplace/creators');
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        mx: 'calc(-50vw + 50%)',
      }}
    >
      <div className="marketplace-wrapper">
        {/* Background Video */}
        <div className="video-background">
          <video autoPlay loop className="background-video">
            <source src="https://kbeanprod.blob.core.windows.net/public-beta/4K%20Website%20video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Foreground Content */}
        <div className="marketplace-content">
          <h4 className="text">An Innovative marketplace for Digital Artwork</h4>
          <h4 className="text"><b>
            Share your art with everyone <br />
            Enjoy your art everywhere <br />
            Get rewards every time
          </b></h4>
          <div className="button-group">
            <button onClick={handleCreatorClick} className="btn">
              I'm a creator
            </button>
            <button onClick={() => navigate('/marketplace/fan')} className="btn">
              I'm a Fan
            </button>
          </div>
        </div>
      </div>

      {/* Intro Modal with Video */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, overflow: 'hidden' }
        }}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(8px)", // 👈 blur effect here
            backgroundColor: "rgba(0,0,0,0.4)", // optional dark overlay
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <video
            autoPlay
            controls
            controlsList="nodownload"
            style={{ width: "100%", height: "100%" }}
          >
            <source src="https://kbeanprod.blob.core.windows.net/public-beta/Explainer%20Video_Creator_Round%202%20Final.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button onClick={handleSkip} variant="contained" color="primary">
          Skip the Intro
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MarketPlace;
